import type { HashicorpCloudResourcemanagerRole } from '@clients/cloud-resource-manager';
import parseRoleId from './parse-role-id.ts';

const SUPER_SELECT_SERVICES: Array<string> = ['secrets'];

/**
 * Returns true if the passed in `roleId` should display a super select when rendering fine grained roles.
 * If you'd like your roleId to display a super select and have multiple selects, modify this function to return true for your roleIds.
 * @param roleId
 */
export function shouldDisplaySuperSelectForRoleId(
  roleId: HashicorpCloudResourcemanagerRole['id'] = '',
): boolean {
  const { service = '' } = parseRoleId(roleId);
  return SUPER_SELECT_SERVICES.includes(service);
}
